import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useCurrency } from '../context/CurrencyContext';

function CouponManage() {
    const [coupons, setCoupons] = useState([]);
    const currencySymbol = useCurrency();
    const [newCoupon, setNewCoupon] = useState({ 
        name: '', 
        min_amount: '', 
        reduction_amount: '',
        is_new_user: 0,
        max_usage: 1
    });
    const [loading, setLoading] = useState(false);

    // 获取 Telegram initData
    const getInitData = () => {
        const tg = window.Telegram?.WebApp;
        if (tg && tg.initData) {
            return tg.initData;
        }
        return '';
    };

    useEffect(() => {
        fetchCoupons();
    }, []);

    const fetchCoupons = async () => {
        try {
            const res = await axios.get('/api/merchant/coupons', {
                headers: { 'x-telegram-init-data': getInitData() }
            });
            setCoupons(res.data.data);
        } catch (error) {
            console.error('获取优惠券失败', error);
            if (error.response?.status === 401) {
                alert('请刷新页面重新登录');
            }
        }
    };

    const addCoupon = async () => {
        if (!newCoupon.name || !newCoupon.min_amount || !newCoupon.reduction_amount) {
            alert('请填写完整信息');
            return;
        }
        setLoading(true);
        try {
            await axios.post('/api/merchant/coupons', {
                name: newCoupon.name,
                min_amount: parseFloat(newCoupon.min_amount),
                reduction_amount: parseFloat(newCoupon.reduction_amount),
                type: 'full_reduction',
                is_new_user: newCoupon.is_new_user,
                max_usage: parseInt(newCoupon.max_usage)
            }, {
                headers: { 'x-telegram-init-data': getInitData() }
            });
            alert('添加成功');
            setNewCoupon({ 
                name: '', 
                min_amount: '', 
                reduction_amount: '',
                is_new_user: 0,
                max_usage: 1
            });
            fetchCoupons();
        } catch (error) {
            alert('添加失败: ' + (error.response?.data?.message || error.message));
        } finally {
            setLoading(false);
        }
    };

    const deleteCoupon = async (id) => {
        if (!window.confirm('确定删除此优惠券吗？')) return;
        try {
            await axios.delete(`/api/merchant/coupons/${id}`, {
                headers: { 'x-telegram-init-data': getInitData() }
            });
            alert('删除成功');
            fetchCoupons();
        } catch (error) {
            alert('删除失败');
        }
    };

    return (
        <div style={{ padding: '20px' }}>
            <h2>优惠券管理</h2>
            <p style={{ color: '#666', marginBottom: '20px' }}>设置满减优惠，顾客购物车会自动计算优惠</p>
            
            <div style={{ background: '#f5f5f5', padding: '20px', borderRadius: '8px', marginBottom: '30px' }}>
                <h3>添加新优惠券</h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginTop: '15px' }}>
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        <input
                            placeholder="优惠券名称 (例: 满32减1)"
                            value={newCoupon.name}
                            onChange={e => setNewCoupon({...newCoupon, name: e.target.value})}
                            style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '4px', flex: 1, minWidth: '150px' }}
                        />
                        <input
                            placeholder="满多少元"
                            type="number"
                            value={newCoupon.min_amount}
                            onChange={e => setNewCoupon({...newCoupon, min_amount: e.target.value})}
                            style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '4px', width: '100px' }}
                        />
                        <input
                            placeholder="减多少元"
                            type="number"
                            value={newCoupon.reduction_amount}
                            onChange={e => setNewCoupon({...newCoupon, reduction_amount: e.target.value})}
                            style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '4px', width: '100px' }}
                        />
                        <button 
                            onClick={addCoupon} 
                            disabled={loading}
                            style={{ padding: '8px 20px', background: '#ff6b6b', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                        >
                            {loading ? '添加中...' : '添加优惠券'}
                        </button>
                    </div>
                    
                    {/* 新人券选项 */}
                    <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: '20px',
                        padding: '12px',
                        background: '#fff',
                        borderRadius: '8px',
                        border: '1px solid #e0e0e0'
                    }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                            <input
                                type="checkbox"
                                checked={newCoupon.is_new_user === 1}
                                onChange={e => setNewCoupon({...newCoupon, is_new_user: e.target.checked ? 1 : 0})}
                                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                            />
                            <span style={{ fontWeight: '500' }}>🎁 新人专享券</span>
                        </label>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span style={{ fontSize: '14px', color: '#666' }}>每人最多使用次数：</span>
                            <select
                                value={newCoupon.max_usage}
                                onChange={e => setNewCoupon({...newCoupon, max_usage: parseInt(e.target.value)})}
                                style={{ padding: '6px 12px', border: '1px solid #ddd', borderRadius: '4px', background: '#fff' }}
                            >
                                <option value={1}>1次</option>
                                <option value={2}>2次</option>
                                <option value={3}>3次</option>
                                <option value={5}>5次</option>
                                <option value={10}>10次</option>
                            </select>
                        </div>
                    </div>
                    <div style={{ fontSize: '12px', color: '#999', marginTop: '-5px' }}>
                        {newCoupon.is_new_user === 1 ? 
                            '✅ 新人专享券：只有从未下过单的新用户才能领取和使用' : 
                            '📌 普通满减券：所有用户都可以领取和使用'}
                    </div>
                </div>
            </div>
            
            <h3>现有优惠券</h3>
            {coupons.length === 0 ? (
                <p style={{ color: '#999' }}>暂无优惠券，点击上方添加</p>
            ) : (
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr style={{ background: '#f5f5f5', borderBottom: '1px solid #ddd' }}>
                            <th style={{ padding: '12px', textAlign: 'left' }}>名称</th>
                            <th style={{ padding: '12px', textAlign: 'left' }}>满减条件</th>
                            <th style={{ padding: '12px', textAlign: 'left' }}>类型</th>
                            <th style={{ padding: '12px', textAlign: 'left' }}>每人限用</th>
                            <th style={{ padding: '12px', textAlign: 'left' }}>操作</th>
                        </tr>
                    </thead>
                    <tbody>
                        {coupons.map(coupon => (
                            <tr key={coupon.id} style={{ borderBottom: '1px solid #eee' }}>
                                <td style={{ padding: '12px' }}>{coupon.name}</td>
                                <td style={{ padding: '12px' }}>满{coupon.min_amount}减{coupon.reduction_amount}</td>
                                <td style={{ padding: '12px' }}>
                                    {coupon.is_new_user === 1 ? (
                                        <span style={{ 
                                            background: '#ff9800', 
                                            color: 'white', 
                                            padding: '2px 8px', 
                                            borderRadius: '12px',
                                            fontSize: '12px'
                                        }}>
                                            🎁 新人专享
                                        </span>
                                    ) : (
                                        <span style={{ 
                                            background: '#4caf50', 
                                            color: 'white', 
                                            padding: '2px 8px', 
                                            borderRadius: '12px',
                                            fontSize: '12px'
                                        }}>
                                            普通满减
                                        </span>
                                    )}
                                </td>
                                <td style={{ padding: '12px' }}>
                                    {coupon.max_usage || 1} 次
                                </td>
                                <td style={{ padding: '12px' }}>
                                    <button 
                                        onClick={() => deleteCoupon(coupon.id)} 
                                        style={{ 
                                            padding: '4px 12px', 
                                            background: '#999', 
                                            color: 'white', 
                                            border: 'none', 
                                            borderRadius: '4px', 
                                            cursor: 'pointer',
                                            fontSize: '12px'
                                        }}
                                    >
                                        删除
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}

export default CouponManage;